import { Record } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { UserSession_$reflection } from "./Shared/ApiDataTypes.js";
import { record_type, list_type, string_type, option_type } from "./fable_modules/fable-library-js.4.24.0/Reflection.js";
import { ScreenSize, ScreenSize_$reflection } from "./fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { empty } from "./fable_modules/fable-library-js.4.24.0/List.js";
import * as react from "react";

export class GlobalCtx extends Record {
    constructor(Session, CurrentPath, Responsive) {
        super();
        this.Session = Session;
        this.CurrentPath = CurrentPath;
        this.Responsive = Responsive;
    }
}

export function GlobalCtx_$reflection() {
    return record_type("Context.GlobalCtx", [], GlobalCtx, () => [["Session", option_type(UserSession_$reflection())], ["CurrentPath", list_type(string_type)], ["Responsive", ScreenSize_$reflection()]]);
}

export function GlobalCtx_New_5646F280(session, path, responsive) {
    return new GlobalCtx(session, path, responsive);
}

export function GlobalCtx_Default() {
    return new GlobalCtx(undefined, empty(), new ScreenSize(3, []));
}

export const globalCtx = (() => {
    const defaultValue = GlobalCtx_Default();
    return react.createContext(defaultValue);
})();

//# sourceMappingURL=Context.js.map
